export enum CharacterTypeEnum {
    Boss = 'boss',
    Main = 'main'
}